import { forwardRef } from 'react';
import {
    MenuControlsContainer,
    MenuButtonBold,
    MenuButtonItalic,
    MenuButtonStrikethrough,
    MenuDivider,
    type RichTextEditorRef,
    LinkBubbleMenuHandler,
    MenuButtonCode,
    MenuButtonBlockquote,
    MenuButtonBulletedList,
    MenuButtonOrderedList,
    MenuButtonEditLink,
} from 'mui-tiptap';
import StarterKit from '@tiptap/starter-kit';
import { Link } from '@tiptap/extension-link';
import type { Editor } from '@tiptap/core';

import { StyledRichTextEditor, StyledLinkBubbleMenu } from './RichTextEditor.styled';

interface RichTextEditorProps {
    onUpdate: (content: string) => void;
    showControls: boolean;
    // eslint-disable-next-line react/require-default-props
    disabled?: boolean;
}

const CustomLinkExtension = Link.extend({
    inclusive: false,
}).configure({
    autolink: true,
    linkOnPaste: true,
    openOnClick: false,
});

function RichTextControls() {
    return (
        <MenuControlsContainer>
            <MenuButtonBold />
            <MenuButtonItalic />
            <MenuButtonStrikethrough />
            <MenuDivider />
            <MenuButtonEditLink />
            <MenuDivider />
            <MenuButtonBulletedList />
            <MenuButtonOrderedList />
            <MenuDivider />
            <MenuButtonBlockquote />
            <MenuButtonCode />
        </MenuControlsContainer>
    );
}

const RichTextEditor = forwardRef<RichTextEditorRef, RichTextEditorProps>(
    ({ onUpdate, showControls, disabled = false }, ref) => {
        return (
            <StyledRichTextEditor
                ref={ref}
                extensions={[StarterKit.configure({ link: false }), LinkBubbleMenuHandler, CustomLinkExtension]}
                editable={!disabled}
                RichTextFieldProps={{
                    variant: 'standard',
                    MenuBarProps: {
                        hide: !showControls,
                    },
                    disabled,
                }}
                renderControls={RichTextControls}
                onUpdate={({ editor }: { editor: Editor }) => {
                    const messageText = editor?.getText().trim();
                    onUpdate(messageText ? editor?.getHTML() : '');
                }}>
                {() => <StyledLinkBubbleMenu placement="top-start" disablePortal />}
            </StyledRichTextEditor>
        );
    }
);

export default RichTextEditor;
